export default __webpack_public_path__ + "static/media/door-out.8f34504b.svg";